var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AttachmentList',{attrs:{"card-id":_vm.card.id,"removable":true},on:{"delete-attachment":_vm.deleteAttachment,"restore-attachment":_vm.restoreAttachment}})
}
var staticRenderFns = []

export { render, staticRenderFns }